<div class="banner-container">
    <a [routerLink]="['home']">
        @if (info && info.HeaderBanner !== '') {
            <img class="base" [src]="'assets/' + (info !== null ? info.HeaderBanner : '')" [title]="system" />
        }
    </a>
</div>
